import React from 'react'
import { ArticleCardMini, Article } from './index'
import Link from 'next/link'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'

type ArticleCardListMiniProps = {
  articlesList?: Article[]
  blogUrl?: string
  onCardClick?: (url?: string) => void
}

export const ArticleCardListMini = ({
  articlesList,
  blogUrl,
  onCardClick,
}: ArticleCardListMiniProps) => {
  const { translate } = useTranslations()
  return (
    <>
      {articlesList && articlesList.length ? (
        <>
          {articlesList.map((article, index) => (
            <div key={`${index}${article.url}`} className="u-mb-24">
              <ArticleCardMini
                url={article.url}
                title={article.title}
                mainImage={article.mainImage}
                onCardClick={onCardClick}
              />
            </div>
          ))}
          {blogUrl ? (
            <Link className="u-opacity-1" prefetch={false} href={blogUrl}>
              {translate('View_More_Guides')}
            </Link>
          ) : null}
        </>
      ) : null}
    </>
  )
}
